export function downloadCsv(csv: string, filename: string): void {
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function promptExportFilename(
  orgName: string,
  collectionId: string,
  from: string,
  to: string,
): string {
  const safeOrg =
    orgName
      .trim()
      .replace(/[/\\:*?"<>|\s]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '') || 'org';
  const collectionPrefix = collectionId.includes('-')
    ? collectionId.split('-')[0]
    : collectionId.slice(0, 8);
  return `${safeOrg}_${collectionPrefix}_${from}_to_${to}.csv`;
}
